
////////////////////////////////////
// M067 quote slider

function initStorySlider(){
    
	if($(".storySlider").length > 0){
		

		$(".storySlider__slider").slick({
            dots: true,
            infinite: true,
            draggable: true,
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '0',
            variableWidth: false,
            adaptiveHeight: false,
            prevArrow: slickPrevArrowCode,
            nextArrow: slickNextArrowCode,
        });

		//preload all images
		$(".storySlider__slider").on('beforeChange', function (event, slick, currentSlide) {
			preloadStorySliderImages();
		});
	}
}

function preloadStorySliderImages(){
	$(".storySlider__slider").find(".storySlider__page-image").each(function(){
		var $img = $(this).children(".b-lazy");
		if(!$img.hasClass("b-loaded") && _blazy){
			_blazy.load($img, true);
		}
	});
}

function updateStorySlider(){
	//console.log("updateStorySlider");
	if($(".storySlider").length > 0){
		
		$(".storySlider").each(function(){
			
			var imgHeight = $(this).find(".storySlider__page-image").height();
			//console.log("updateStorySlider imgHeight:" + imgHeight);
			$(this).find(".slick-arrow").css("height", Math.floor(imgHeight) + "px");
		});
	}
}
